<template>
  <section class="section">
    <div class="container is-max-widescreen is-max-desktop">
      <h1 class="title has-text-centered">
        Suivi en temps réel {{ displayDays ? '(en jours)' : '(en heures)' }}
      </h1>

      <hr>

      <div class="columns">
        <div class="column">

          <div class="columns">
            <div class="column is-half">
              <SelectProject
                  @updateProject="updateProject">
              </SelectProject>
            </div>
            <div class="column">
              <SelectStatusProject
                  @updateStatusProject="updateStatusProject">
              </SelectStatusProject>
            </div>
            <div class="column">
              <b-field label="Tâches orphelines">
                <b-switch
                v-model="orpheanTasks">
                  Afficher
                </b-switch>
              </b-field>
            </div>
          </div>

          <br>

          <div class="columns">
            <div class="column">

              <SelectEmployee
                  @updateEmployee="updateEmployee">
              </SelectEmployee>

              <hr>

              <!--

              <b-field
              label="Tous les projets et tous les employés">
                <b-checkbox v-model="requestAll">
                  {{ requestAll ?
                    "Attention, beaucoup de données, seul l'export sera disponible"
                    :
                    '' }}
                </b-checkbox>
              </b-field>

              -->

            </div>
            <div class="column">

              <!-- Choix status projet -->

            </div>

          </div>

        </div>
        <div class="column">
          <b-field label="Date de début de la saisie du temps">
            <b-datepicker
                v-model="startDate"
                locale="fr-FR"
                placeholder="Click to select..."
                icon="calendar-alt"
                :icon-right="startDate ? 'times-circle' : ''"
                icon-right-clickable
                @icon-right-click="clearStartDate"
                trap-focus>
            </b-datepicker>
          </b-field>

          <b-field label="Date de fin de la saisie du temps">
            <b-datepicker
                v-model="endDate"
                locale="fr-FR"
                placeholder="Click to select..."
                icon="calendar-alt"
                :icon-right="endDate ? 'close-circle' : ''"
                icon-right-clickable
                @icon-right-click="clearEndDate"
                trap-focus>
            </b-datepicker>
          </b-field>

          <p><b>Légende</b></p>
          <br>

            <b-field>
              <b-icon
                  icon="times-circle"
                  type="is-danger"
              >
              </b-icon>
              Impossible de finir la tâche avant sa date de fin (si feuille de temps à jour).
            </b-field>

            <b-field>
              <b-progress
                  :value="100"
                  type="is-danger"
                  show-value
                  size="is-large">
                Surproduction
              </b-progress>
            </b-field>

          <b-field>
            <b-progress
                :value="100"
                type="is-success"
                show-value
                size="is-large">
              Temps prévu consommé
            </b-progress>
          </b-field>

          <b-field>
            <b-progress
                :value="90"
                type="is-warning"
                show-value
                size="is-large">
              Plus de 80% réalisé
            </b-progress>
          </b-field>

          <b-field>
            <b-progress
                :value="70"
                type="is-info"
                show-value
                size="is-large">
              Moins de 80% réalisé
            </b-progress>
          </b-field>




        </div>


      </div>

      <b-field grouped>

        <b-field label="Exécuter la requête">
          <b-button
              @click="getTable"
              type="is-success">
            Valider</b-button>
        </b-field>

        <b-field
            label="Télécharger sous format tableur"
            v-if="tasks.length > 0">
          <b-button
              @click="downloadSpreadsheet"
              type="is-info">
            Télécharger</b-button>
        </b-field>

        <b-switch
            v-model="displayDays"
            label="Afficher les heures"
            type="is-primary">
          Afficher en jours
        </b-switch>

      </b-field>






      <hr>

      <!-- Tabs -->
      <b-tabs type="is-boxed">
        <b-tab-item :label=" 'Tâches (' + tasks.length + ')'" icon="tasks">
          <b-table
              :data="tasks"
              hoverable
              striped
              searchable
          >

            <b-table-column
                field="project"
                label="Projet"
                searchable
                :custom-search="searchProject"
                v-slot="props">
              <b> {{ props.row.projectFullName }}</b>
            </b-table-column>

            <b-table-column
                field="phase"
                label="Phases"
                searchable
                :custom-search="searchPhase"
                v-slot="props">
              <b>{{ props.row.fullName }}</b>
            </b-table-column>

            <b-table-column
                field="taches"
                label="Tâches"
                width="300"
                searchable
                :custom-search="searchTask"
                v-slot="props">
              <div style="max-width: 300px; word-wrap: break-word; word-break: break-word;">
                {{ props.row.name }}
              </div>
            </b-table-column>

            <b-table-column
                field="assigned"
                label="Assigné à"
                searchable
                :custom-search="searchEmployee"
                v-slot="props">
              {{ props.row.assignedTo }}
            </b-table-column>

            <b-table-column
                field="prevu"
                label="Prévu"
                v-slot="props">
              {{ makeDays(props.row.budgetedTime) }}
            </b-table-column>

            <b-table-column
                width="100"
                field="realise"
                label="Réalisé total"
                v-slot="props">
              {{ makeDays(props.row.realtime) }}
            </b-table-column>

            <b-table-column
                width="100"
                field="realise"
                label="Réalisé validé"
                v-slot="props">
              {{ makeDays(props.row.totalRealHrs) }}
            </b-table-column>

            <b-table-column
                width="100"
                field="realise"
                label="Réalisé total sur la période filtrée"
                v-slot="props">
              {{ makeDays(props.row.realtimedf) }}
            </b-table-column>

            <b-table-column
                field="restant"
                label="Restant total"
                v-slot="props">
              <b-tooltip
                  class="pointer">
                <template v-slot:content>
                  {{ getBusinessDatesCount(props.row.taskEndDate) }} jours ouvrés avant la fin de la tâche
                </template>

                <b-field grouped>
                <b-progress :type="
                                    [
                                        {'is-info':
                                            props.row.realtime / props.row.budgetedTime < 0.80
                                        },
                                        {'is-warning':
                                            props.row.realtime / props.row.budgetedTime < 0.99 &&
                                            props.row.realtime / props.row.budgetedTime >= 0.80
                                        },
                                        {'is-success':
                                            props.row.realtime / props.row.budgetedTime <= 1.01 &&
                                            props.row.realtime / props.row.budgetedTime >= 0.99
                                        },
                                        {'is-danger':
                                            props.row.realtime / props.row.budgetedTime > 1.01
                                        },
                                    ]"
                            :value="Math.round((props.row.realtime / props.row.budgetedTime) * 100)"
                            show-value
                            size="is-large">
                  {{ makeDays( (props.row.budgetedTime - props.row.realtime) ) }}
                </b-progress>

                  &nbsp;

                <b-icon
                    icon="times-circle"
                    type="is-danger"
                    v-if="(props.row.budgetedTime - props.row.realtime) > 0">
                </b-icon>

                </b-field>


              </b-tooltip>
            </b-table-column>

            <b-table-column
                field="periode"
                label="Période"
                v-slot="props">
              {{ props.row.taskDate }} / {{ props.row.taskEndDate }}
            </b-table-column>

              <b-table-column
                  field="imputable"
                  label="Imputable"
                  searchable
                  :custom-search="searchImputable"
                  v-slot="props">
                  {{ props.row.imputable }}
              </b-table-column>

          </b-table>
        </b-tab-item>


        <b-tab-item :label=" 'Projet x salarié (' + projects.length + ')'" icon="folder-open">

          <b-table
              :data="projects"
              hoverable
              striped
              searchable
          >

            <b-table-column
                field="project"
                label="Projet"
                searchable
                :custom-search="searchProject"
                v-slot="props">
              <b> {{ props.row.projectFullName }}</b>
            </b-table-column>

            <b-table-column
                field="phase"
                label="Phases"
                searchable
                :custom-search="searchPhase"
                v-slot="props">
              <b>{{ props.row.fullName }}</b>
            </b-table-column>

            <b-table-column
                field="taches"
                label="Tâches"
                width="300"
                searchable
                :custom-search="searchTask"
                v-slot="props">
              <div style="max-width: 300px; word-wrap: break-word; word-break: break-word;">
                {{ props.row.name }}
              </div>
            </b-table-column>

            <b-table-column
                field="assigned"
                label="Assigné à"
                searchable
                :custom-search="searchEmployee"
                v-slot="props">
              {{ props.row.assignedTo }}
            </b-table-column>

            <b-table-column
                field="prevu"
                label="Prévu"
                v-slot="props">
              {{ makeDays(props.row.budgetedTime) }}
            </b-table-column>

            <b-table-column
                width="100"
                field="realise"
                label="Réalisé total"
                v-slot="props">
              {{ makeDays(props.row.realtime) }}
            </b-table-column>

            <b-table-column
                width="100"
                field="realise"
                label="Réalisé validé"
                v-slot="props">
              {{ makeDays(props.row.totalRealHrs) }}
            </b-table-column>

            <b-table-column
                width="100"
                field="realise"
                label="Réalisé total sur la période"
                v-slot="props">
              {{ makeDays(props.row.realtimedf) }}
            </b-table-column>

            <b-table-column
                field="restant"
                label="Restant total"
                v-slot="props">

                <b-progress :type="
                                    [
                                         {'is-info':
                                            props.row.realtime / props.row.budgetedTime < 0.80
                                        },
                                        {'is-warning':
                                            props.row.realtime / props.row.budgetedTime < 0.99 &&
                                            props.row.realtime / props.row.budgetedTime >= 0.80
                                        },
                                        {'is-success':
                                            props.row.realtime / props.row.budgetedTime <= 1.01 &&
                                            props.row.realtime / props.row.budgetedTime >= 0.99
                                        },
                                        {'is-danger':
                                            props.row.realtime / props.row.budgetedTime > 1.01
                                        },
                                    ]"
                            :value="Math.round((props.row.realtime / props.row.budgetedTime) * 100)"
                            show-value
                            size="is-large">
                  {{ makeDays( (props.row.budgetedTime - props.row.realtime) ) }}
                </b-progress>

            </b-table-column>

              <b-table-column
                  field="imputable"
                  label="Imputable"
                  searchable
                  :custom-search="searchImputable"
                  v-slot="props">
                  {{ props.row.imputable }}
              </b-table-column>

          </b-table>


        </b-tab-item>

          <b-tab-item label="Vue Gantt (en dev)" icon="graph">

                <span id="gantt"></span>

          </b-tab-item>

      </b-tabs>

    </div>

  </section>
</template>

<script>

import SelectProject from "@/components/HELPERS/SelectProject";
import SelectEmployee from "@/components/HELPERS/SelectEmployee";
import SelectStatusProject from "@/components/HELPERS/SelectStatusProject";
import Gantt from 'frappe-gantt'

export default {
  name: "TableSuiviRT",
  components: {SelectStatusProject, SelectProject, SelectEmployee},
  mounted() {
  },
  computed: {

  },
  methods: {

      makeGantt(){

          let tasks = [];

          this.tasks.forEach(t => {
              console.log(t)
              tasks.push({
                  id: 'Task 1',
                  name: t.employeeXproject,
                  desc: t.name,
                  start: t.taskDate,
                  end: t.taskEndDate,
                  progress: t.realtime * 100 / t.budgetedTime,
                  // custom_class: 'bar-milestone' // optional
              })
          })
          // https://blog.logrocket.com/gantt-chart-javascript-frappe-gantt/
          let gantt = new Gantt('#gantt', tasks, {
              // can be a function that returns html
              // or a simple html string
              custom_popup_html: function(task) {
                  // the task object will contain the updated
                  // dates and progress value
                  // const end_date = task._end.format('MMM D');
                  return `  <div>
                              <h5>${task.desc}</h5>
                            </div>
                          `;
              }
          });
          gantt.change_view_mode('Month') // Quarter Day, Half Day, Day, Week, Month
      },

    downloadSpreadsheet(){
      // Trigger spreadsheet download from buffer
          const link = document.createElement('a');
          link.href = "data:application/vnd.ms-excel;base64," + this.spreadsheetBuffer;
          link.setAttribute('download', 'export.xlsx');
          document.body.appendChild(link);
          link.click();
    },

    makeDays(hours) {
      if (this.displayDays) {
        if (hours === 0) {
          return 0;
        } else {
          return (hours / 7.8).toFixed(2);
        }
      } else {
        return hours.toFixed(2);
      }
    },

    getTable() {
      // Check data integrity
      if (this.project === 0 && this.employee === 0 && this.requestAll === false) {
        this.$buefy.snackbar.open({
          duration: 4000,
          message: 'Veuillez sélectionner des filtres',
          type: 'is-danger',
          position: 'is-bottom-left',
        })
        return
      }

      let s = this.startDate.toLocaleDateString ("fr-CA")
      let e = this.endDate.toLocaleDateString ("fr-CA")

      const loadingComponent = this.$buefy.loading.open({
        container: null
      })

      this.$axios.get(`tablesuivirt?project=${this.project}&employee=${this.employee}&startDate=${s}&endDate=${e}&statusProject=${this.statusProject}&orpheanTasks=${this.orpheanTasks}`)
          .then(response => {

            if (!this.requestAll) {
              response.data.tasks.sort((a, b) => {
                return (a.budgetedTime - a.realtime) > (b.budgetedTime - b.realtime) ? 1 : -1
              })
              response.data.projects.sort((a, b) => {
                return (a.budgetedTime - a.realtime) > (b.budgetedTime - b.realtime) ? 1 : -1
              })
              this.tasks = response.data.tasks;
              this.projects = response.data.projects;
            }

            this.spreadsheetBuffer = response.data.spreadsheet;

            this.makeGantt()

            loadingComponent.close()

                if (this.requestAll) {
                  this.$buefy.snackbar.open({
                    duration: 4000,
                    message: 'Cliquez sur Télécharger pour récupérer le tableur',
                    type: 'is-success',
                    position: 'is-bottom-left',
                  })
                }

          })
          .catch(e => {
            console.log(e);
            loadingComponent.close()
          });
    },

    getBusinessDatesCount(endDate) {
      endDate = new Date(endDate);
      let count = 0;
      const curDate = new Date();
      while (curDate <= endDate) {
        const dayOfWeek = curDate.getDay();
        if(dayOfWeek !== 0 && dayOfWeek !== 6) count++;
        curDate.setDate(curDate.getDate() + 1);
      }
      return count;
    },

    updateProject: function(project){
      this.project = project === null ? 0 : project.id;
    },

    updateEmployee: function(employee){
      this.employee = employee === null ? 0 : employee.id;
    },

    updateStatusProject: function(statusProject){
      this.statusProject = statusProject === null ? 0 : statusProject;
    },

    searchProject(row, input) {
      input = input.toLowerCase()
      return input && row.projectFullName.toLowerCase() && row.projectFullName.toLowerCase().includes(input);
    },

    searchEmployee(row, input) {
      input = input.toLowerCase()
      return input && row.assignedTo.toLowerCase() && row.assignedTo.toLowerCase().includes(input);
    },

    searchPhase(row, input) {
      input = input.toLowerCase()
      return input && row.fullNametoLowerCase() && row.fullName.toLowerCase().includes(input);
    },
    searchTask(row, input) {
      input = input.toLowerCase()
      return input && row.nametoLowerCase() && row.name.toLowerCase().includes(input);
    },
      searchImputable(row, input) {
          input = input.toLowerCase()
          return input && row.imputable.toLowerCase().includes(input);
      },

    clearStartDate () {
      this.startDate = null
    },
    clearEndDate () {
      this.endDate = null
    },

},
  data() {
    return {
      displayDays: false,
      requestAll: false,
      tasks: [],
      projects: [],
      spreadsheetBuffer: null,
      project: 0,
      employee: 0,
      statusProject: 0,
      orpheanTasks: false,
      startDate: new Date(),
      endDate: new Date(),
    }
  }
}
</script>

<style scoped>

.container {
  max-width: 100%;
  padding-left: 1%;
  padding-right: 1%;
}

.pointer {
  cursor: pointer;
}

</style>
